import { useQuery } from '@tanstack/react-query';
import { getFinancesServiceFeeDetails, queryKeys } from '@vgrubs/components';
import { SaasRange } from '../SaasDetails/saasDetails.helpers';

/**
 * Where "Service Fee" came from for one range: card vs cash, by partner and
 * by location. Only fetched while the modal is open.
 */
export const useServiceFeeDetails = (range: SaasRange, enabled: boolean) => {
  const query = useQuery({
    queryKey: queryKeys.admin.serviceFeeDetails(range),
    queryFn: async () => {
      const { data } = await getFinancesServiceFeeDetails(range);
      return data.data;
    },
    enabled,
  });

  return {
    details: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
